/**
 * @desc 请求或更新报告
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(body: defs.report.ReportTaskRecordRpcRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/reportRequest`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
